<template>
  <div>
    <div>
      <h5>Aller</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          <DatePickerComponent
            value-key="transportation.outboundDate"
            label="Date Arrivée"
            placeholder=""
            :required="false"
            class="mb-3"
            :min-date="participation?.travel?.startDate ? dayjs(participation.travel.startDate).add(-15, 'days').toDate() : null"
            :max-date="participation?.travel?.endDate ? dayjs(participation.travel.endDate).add(15, 'days').toDate() : null"
            :disabled="props.lockDates"
          />
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <DatePickerComponent
            value-key="transportation.outboundTime"
            label="Heure Arrivée"
            placeholder=""
            :required="false"
            class="mb-3"
            :only-time-picker="true"
            :format="'HH:mm'"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          <TextInputComponent
            value-key="transportation.outboundCompany"
            label="Compagnie"
            placeholder="Compagnie"
            :required="false"
            class="mb-3"
            :upper-case="true"
          />
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <TextInputComponent
            value-key="transportation.outboundFlightNumber"
            label="N° Vol"
            placeholder="N° Vol"
            :required="false"
            class="mb-3"
            :upper-case="true"
          />
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <TextInputComponent
            value-key="transportation.outboundAirport"
            label="Aéroport Départ"
            placeholder="Aéroport Départ"
            :required="false"
            class="mb-3"
            :upper-case="true"
          />
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <TextInputComponent
            value-key="transportation.outboundAirportLastStop"
            label="Aéroport Dernière Escale"
            placeholder="Aéroport Dernière Escale"
            :required="false"
            class="mb-3"
            :upper-case="true"
          />
        </div>
      </div>
    </div>
    <div class="mt-3">
      <h5>Retour</h5>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          <DatePickerComponent
            value-key="transportation.returnDate"
            label="Date Départ"
            placeholder=""
            :required="false"
            class="mb-3"
            :min-date="participation?.travelInfo?.customStartDate ?? new Date()"
            :max-date="participation?.travel?.endDate ? dayjs(participation.travel.endDate).add(15, 'days').toDate() : null"
            :disabled="props.lockDates"
          />
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <DatePickerComponent
            value-key="transportation.returnTime"
            label="Heure Décollage"
            placeholder=""
            :required="false"
            class="mb-3"
            :only-time-picker="true"
            :format="'HH:mm'"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-xl-3">
          <TextInputComponent
            value-key="transportation.returnCompany"
            label="Compagnie"
            placeholder="Compagnie"
            :required="false"
            class="mb-3"
            :upper-case="true"
          />
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <TextInputComponent
            value-key="transportation.returnFlightNumber"
            label="N° Vol"
            placeholder="N° Vol"
            :required="false"
            class="mb-3"
            :upper-case="true"
          />
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <TextInputComponent
            value-key="transportation.returnAirport"
            label="Aéroport Retour"
            placeholder="Aéroport Retour"
            :required="false"
            class="mb-3"
            :upper-case="true"
          />
        </div>
        <div class="col-12 col-md-6 col-xl-3">
          <TextInputComponent
            value-key="transportation.returnAirportLastStop"
            label="Aéroport Dernière Escale"
            placeholder="Aéroport Dernière Escale"
            :required="false"
            class="mb-3"
            :upper-case="true"
          />
        </div>
      </div>
      <div class="text-muted text-center">
        <small><i class="fa-solid fa-triangle-exclamation text-warning"></i> Si vous n'avez pas encore votre billet, merci de l'envoyer à l'Organisation dès que possible : <a :href="`mailto:${participation?.travel?.emailContact ?? 'mynemo@nemoprod.fr'}`"  target="_blank" title="Contacter l'équipe Nemo">{{ participation?.travel?.emailContact ?? 'mynemo@nemoprod.fr' }}</a></small>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';

const participation = defineModel<UserParticipation>();
const props = withDefaults(defineProps<{
  lockDates: boolean;
}>(), {
  lockDates: false,
});

</script>
